<template>
  <div class="quantity-container">
    <div v-if="item.qty <= 1" @click="deleteItem" class="icon-container h-100 bg-primary px-2 flex-center left-toggle">
      <i title="Delete" class="text-white fa fa-trash icon"></i>
    </div>
    <div v-else @click="decrement" class="icon-container h-100 bg-primary px-2 flex-center left-toggle">
      <i title="Remove Item" class="fas fa-minus text-white icon"></i>
    </div>
    <input class="form-control col-lg-10 p-2" pattern="[0-9]" :value="item.qty" @blur="quantityChanged"/>
    <div @click="increment" class="icon-container h-100 bg-primary px-2 flex-center right-toggle">
      <i title="Add Item" class="fas fa-plus icon text-white"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  methods: {
    quantityChanged($event) {
      if ($event.target.value > 0 && $event.target.value.length) {
        this.$emit('quantityChanged', $event, this.item)
      }
    },
    deleteItem() {
      this.$emit('deleteItem', this.item)
    },
    increment() {
      this.$emit('increment', this.item)
    },
    decrement() {
      this.$emit('decrement', this.item)
    }
  }
}
</script>

<style>
.quantity-container {
  display: flex;
  align-items: center;
  height: 25px;
}

.quantity-container input {
  height: 25px;
  width: 50px;
  max-width: 50px;
  border-radius: 0;
}

@media (max-width: 576px) {
  .quantity-container input {
    width: 35px;
  }
}

.quantity-container input:focus {
  box-shadow: none;
}

.quantity-container .icon-container {
  cursor: pointer;
}

.quantity-container .icon {
  font-size: 12px;
}

.left-toggle {
  border-radius: 3px 0 0 3px;
}

.right-toggle {
  border-radius: 0 3px 3px 0;
}

</style>
